import FAQ from '../containers/FAQ';

export default FAQ;
